// extracted by mini-css-extract-plugin
export default {"PageError":"HSFBbkPF"};
    if(module.hot) {
      // 1764331277392
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  